module.exports = __webpack_public_path__ + "img/05.d4f2600d.jpg";